import React, { createContext } from 'react';
import { defaultBackgroundColor, defaultForegroundColor, defaultLocalizationMap } from '../constants';
import { IUserData, ILocalizationMap, IHeaderTheme } from '../SuiteHeader.types';

interface ISuiteHeaderProviderProps {
  context: ISuiteHeaderContext;
}

/**
 * Data shared by the all the components of the header
 */
export interface ISuiteHeaderContext {
  readonly theme?: IHeaderTheme;
  readonly culture: string;
  readonly workloadId: string;
  readonly userData: IUserData;
  readonly localizationMap: ILocalizationMap;
  readonly appId: string;
}

const initialValue: ISuiteHeaderContext = {
  theme: {
    backgroundColor: defaultBackgroundColor,
    foregroundColor: defaultForegroundColor
  },
  appId: '',
  culture: '',
  workloadId: '',
  userData: {
    tenantDisplayName: '',
    tenantId: '',
    upn: '',
    imageUrl: '',
    name: '',
    homeTenantId: '',
    rawClaims: {}
  },
  localizationMap: defaultLocalizationMap
};

export const SuiteHeaderContext = createContext<ISuiteHeaderContext>(initialValue);

export const SuiteHeaderProvider: React.FC<ISuiteHeaderProviderProps> = ({ children, ...value }) => {
  const context = value.context;
  return <SuiteHeaderContext.Provider value={context}>{children}</SuiteHeaderContext.Provider>;
};
